import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [55.638215, -5.223567, 35.8],
  [55.638199, -5.223741, 35.8],
  [55.638199, -5.223919, 35.8],
  [55.638204, -5.224098, 35.8],
  [55.63821, -5.224278, 35.8],
  [55.638215, -5.224458, 35.8],
  [55.63822, -5.22464, 35.8],
  [55.63821, -5.224821, 35.8],
  [55.638188, -5.225, 35.8],
  [55.638151, -5.225169, 35.8],
  [55.638092, -5.225323, 35.8],
  [55.638027, -5.225459, 36],
  [55.637947, -5.225579, 36.2],
  [55.637866, -5.225689, 36.4],
  [55.637786, -5.225792, 36.6],
  [55.637705, -5.225892, 36.6],
  [55.637625, -5.225992, 36.8],
  [55.637544, -5.226098, 37],
  [55.637469, -5.22621, 37.2],
  [55.6374, -5.226324, 37.4],
  [55.637324, -5.226443, 37.6],
  [55.637271, -5.226576, 37.6],
  [55.637223, -5.226726, 37.8],
  [55.63719, -5.226885, 37.8],
  [55.637158, -5.227047, 37.8],
  [55.63711, -5.227196, 38],
  [55.637046, -5.22733, 38],
  [55.636981, -5.227454, 38],
  [55.636906, -5.227573, 38],
  [55.636836, -5.22769, 38],
  [55.636761, -5.227808, 38],
  [55.636691, -5.227936, 38],
  [55.636632, -5.228077, 38],
  [55.636579, -5.228233, 38],
  [55.636547, -5.2284, 38],
  [55.63652, -5.228579, 37.8],
  [55.636509, -5.228763, 37.6],
  [55.636498, -5.228952, 37.2],
  [55.636488, -5.229143, 37],
  [55.636482, -5.229338, 36.8],
  [55.636472, -5.229536, 36.4],
  [55.636472, -5.229737, 36.2],
  [55.636482, -5.229939, 36],
  [55.636504, -5.230137, 35.8],
  [55.636547, -5.230323, 35.8],
  [55.636622, -5.23048, 35.8],
  [55.636718, -5.230591, 35.8],
  [55.636826, -5.230637, 36],
  [55.636933, -5.230599, 36],
  [55.637035, -5.230513, 36.2],
  [55.637131, -5.230432, 36.6],
  [55.637239, -5.230438, 36.8],
  [55.637324, -5.230541, 37],
  [55.637367, -5.230704, 37.4],
  [55.637389, -5.23088, 37.6],
  [55.637394, -5.231057, 37.8],
  [55.637405, -5.231231, 38],
  [55.637448, -5.231387, 38.2],
  [55.637523, -5.231499, 38.2],
  [55.637614, -5.231553, 38.4],
  [55.637711, -5.231568, 38.4],
  [55.637813, -5.231558, 38.6],
  [55.637909, -5.231536, 38.6],
  [55.638006, -5.23153, 38.6],
  [55.638102, -5.231566, 38.8],
  [55.638188, -5.231642, 39],
  [55.638263, -5.231751, 39.2],
  [55.638328, -5.231878, 39.4],
  [55.638381, -5.232018, 39.6],
  [55.63843, -5.232165, 39.6],
  [55.638472, -5.232315, 39.6],
  [55.638515, -5.23247, 39.6],
  [55.638553, -5.232631, 39.6],
  [55.63858, -5.232801, 39.6],
  [55.638585, -5.232977, 39.6],
  [55.638569, -5.233152, 39.6],
  [55.638526, -5.233314, 39.6],
  [55.638462, -5.233447, 39.6],
  [55.638376, -5.233543, 39.6],
  [55.638274, -5.233598, 39.6],
  [55.638172, -5.233621, 39.4],
  [55.63807, -5.233625, 39.2],
  [55.637963, -5.233631, 39.2],
  [55.637861, -5.233654, 39],
  [55.637754, -5.23369, 38.8],
  [55.637646, -5.233732, 38.6],
  [55.637539, -5.233774, 38.6],
  [55.637432, -5.233804, 38.6],
  [55.637324, -5.233819, 38.6],
  [55.637212, -5.233825, 38.6],
  [55.637105, -5.233823, 38.8],
  [55.636997, -5.233816, 38.8],
  [55.63689, -5.233803, 39],
  [55.636783, -5.233785, 39],
  [55.636681, -5.233767, 39.2],
  [55.636573, -5.233775, 39.4],
  [55.636477, -5.233826, 39.4],
  [55.636386, -5.233918, 39.6],
  [55.636311, -5.234043, 39.6],
  [55.636252, -5.234191, 39.8],
  [55.636203, -5.234351, 40],
  [55.636171, -5.23452, 40],
  [55.636144, -5.234693, 40.2],
  [55.636123, -5.234868, 40.2],
  [55.636107, -5.235043, 40.4],
  [55.636096, -5.235217, 40.6],
  [55.636085, -5.235393, 40.8],
  [55.636075, -5.235565, 41],
  [55.636064, -5.235736, 41.2],
  [55.636058, -5.235904, 41.6],
  [55.636048, -5.236071, 41.8],
  [55.636042, -5.236237, 42],
  [55.636042, -5.236401, 42.2],
  [55.636042, -5.236563, 42.6],
  [55.636048, -5.236723, 42.8],
  [55.636058, -5.236881, 43],
  [55.636085, -5.237035, 43.4],
  [55.636112, -5.237181, 43.6],
  [55.63616, -5.237314, 43.8],
  [55.636219, -5.237422, 44.2],
  [55.636294, -5.237495, 44.4],
  [55.63638, -5.23753, 44.4],
  [55.636466, -5.237532, 44.6],
  [55.636552, -5.237515, 44.8],
  [55.636638, -5.237494, 44.8],
  [55.636729, -5.237479, 45],
  [55.636815, -5.237477, 45],
  [55.636906, -5.237483, 45.2],
  [55.636997, -5.237498, 45.4],
  [55.637083, -5.23752, 45.6],
  [55.637169, -5.237552, 45.8],
  [55.63726, -5.237592, 46],
  [55.637346, -5.237639, 46],
  [55.637426, -5.237695, 46.2],
  [55.637512, -5.237759, 46.6],
  [55.637587, -5.237829, 46.8],
  [55.637668, -5.237907, 47],
  [55.637738, -5.23799, 47.2],
  [55.637813, -5.238081, 47.4],
  [55.637882, -5.238177, 47.6],
  [55.637947, -5.238278, 47.8],
  [55.638006, -5.238386, 48.2],
  [55.638065, -5.238498, 48.4],
  [55.638118, -5.238617, 48.6],
  [55.638161, -5.238741, 48.8],
  [55.638204, -5.238872, 49.2],
  [55.638231, -5.239011, 49.4],
  [55.638247, -5.239156, 49.6],
  [55.638247, -5.239302, 49.8],
  [55.638247, -5.23945, 50],
  [55.638247, -5.239598, 50.2],
  [55.63829, -5.239733, 50.4],
  [55.638344, -5.239843, 50.8],
  [55.638403, -5.239941, 51.2],
  [55.638467, -5.24003, 51.4],
  [55.638531, -5.240112, 51.8],
  [55.638601, -5.240184, 52],
  [55.638671, -5.240248, 52],
  [55.638751, -5.240303, 52.2],
  [55.638826, -5.240352, 52.4],
  [55.638907, -5.240391, 52.6],
  [55.638987, -5.240415, 53],
  [55.639068, -5.240425, 53.2],
  [55.639148, -5.240427, 53.4],
  [55.639229, -5.240424, 53.6],
  [55.639315, -5.240421, 53.6],
  [55.6394, -5.240417, 53.8],
  [55.639481, -5.240409, 53.8],
  [55.639572, -5.240391, 53.8],
  [55.639658, -5.240369, 53.8],
  [55.639744, -5.240347, 53.8],
  [55.639835, -5.24034, 53.6],
  [55.639932, -5.240347, 53.6],
];

export default stream;
